import { Marvin404Icon } from "../primitives/icons/marvin/Marvin404Icon"

/** Shared by the app and marketing website; no animation runtime required. */
export function NotFoundLogo() {
  return <Marvin404Icon size={64} className="size-16 shrink-0 text-black dark:text-white" />
}
